import slugify from '../../utils/slugify';


const artisticProgram = {
  audioDescription: [
    {
      title: "Arrëthyesi",
      subtitle: "Shfaqja e parë zyrtare me audiopërshkrim në Shqipëri",
      description: `<p>Projekti “ArtNexus” me implementim të UNAA-s (United Nations Association Albania), në kuadër të krijimit të një mjedisi ku respekti dhe kremtimi i diversitetit, ndërthuren në strukturën e skenës artistike, zhvilloi më datë 22 dhjetor 2023 një ndër aktivitetet më të përveçme të programit.</p>
                    <p>Në bashkëpunim me Teatrin Kombëtar të Operës dhe Baletit, individë me shikim të kufizuar ishin të ftuarit e veçantë në premierën e baletit emblematik “Arrëthyesi” të Tchaikovsky-t. Përpara shfaqjes u zhvillua një tour, i cili i familjarizoi edhe një herë ndjekësit me historinë e mirënjohur të “Arrëthyesit”, si dhe me veçantitë e produksionit, duke nisur nga kostumet. Shfaqja u çel me një fjalim të Kristi Çinës, presidenti i United Nations Association Albania, i cili theksoi rëndësinë e ndërmarrjes së strategjive që mundësojnë promovimin e nismave gjithëpërfshirëse, sidomos në fushën e artit.</p>
                    <p>Kjo premierë shërbeu si një shembull i këtyre strategjive në sajë të përshkrimit zanor live, i realizuar nga folësi Genti Mumajesi. Folësi është specializuar në interpretimin vizual të shfaqjes, i cili solli në jetë përformancën për të gjithë individët me shikim të dëmtuar, në sajë të përshkrimit zanor të balerinëve dhe akteve. Premiera shënon edhe herën e parë në spektaklin shqiptar, që një balet sillet në audiopërshkrim.</p>
                    <p>Përmes një ftesë të hapur, mundën të bashkohen pjesëtarë të komunitetit me shikim të dëmtuar si dhe pjesëtarë të Shoqatës së të Verbërve të Shqipërisë. Ishin rreth 60 individë me shikim të dëmtuar, të cilët në sajë të ndihmës së stafit të UNAA-s dhe të TKOB-it, u pritën me ngrohtësi dhe me gjithë logjistikën përkatëse për perceptimin e shfaqjes me efikasitet.</p>
                  `,
      imgSrc: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/Karta.jpg",
      imgAlt: "Posteri paraqet një kukull ushtari druri, tipik i arrëthyesit në një sfond festiv krishtlindjesh me pemë dekorative dhe drita. Me shkronja të bardha është shkruar: premierë Arrëthyesi. Shfaqja e pare me audio përshkrim 22.12 ora 19.00. Poshtë gjenden logot e TKOB, ArtNexus, Suedise, UNAA dhe ANNEX.",
      posterImgSrc: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/KOPERTINA.jpg",
      posterImgAlt: "Fotografi me ngjyra nga shfaqja Arrëthyesi. Në skenë duken balerinët të veshur me kostumet e personazheve të Arrëthyesit duke kërcyer shpengueshëm. Në mes të skenës në pozicion sparkade një balerin i veshur si kukull, përreth tij personazhe të tjerë si të cilët e shohin me habi.",
      linkText: "Mësoni më shumë",
      audioSrc: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/audio/Akt_I-01.mp4",
      category: "audioDescription",
      addedDate: new Date(),
      // videoLinks: [
      //   'https://www.youtube.com/watch?v=VIDEO_ID_1',
      //   'https://www.youtube.com/watch?v=VIDEO_ID_2'
      // ],
      synopsis: {
        acts: [
          {
            title: "Akti 1",
            scenes: [
              {
                title: "Skena 1: Shtëpia e Z. Stahlbaum",
                content: `<p>Në prag të Krishtlindjeve, familjarë dhe miq janë mbledhur në sallonin e shtëpisë për të zbukuruar pemën e bukur të Krishtlindjeve në vigjilje të festës. Pasi e përfundojnë atë, vijnë fëmijët, të cilët qëndrojnë të mahnitur përpara pemës që vezullon nga dritat dhe zbukurimet.</p>
                          <p>Fillon festa nën tingujt e një marshi. Fëmijëve i shpërndahen dhurata. Papritur kur ora e vjetër tingëllon 8-të, në dhomë hyn një personazh misterioz. Është Droselmajer, një këshilltar lokal i cili është edhe magjistar dhe njëkohësisht gjyshi i Klarës. Ai është shumë i talentuar në prodhimin e lodrave dhe ka sjellë me vete shumë dhurata për fëmijët, dhe mes tyre 4 kukulla që ngjajnë si të vërteta të cilat vallëzojnë para vështrimeve të mahnitura të të prainshmëve. Pasi performanca përfundon, ai i merr kukullat për ti ruajtur në një vend të sigurtë.</p>
                          <p>Klara dhe Fritz trishtohen kur kukullat largohen por Drosselmeyer ka akoma edhe një lodër për ta: një arrëthyes të drunjtë i cili është gdhendur në formën e një burri të vogël e që shërben për të thyer arrat. Fëmijët e tjerë i kthejnë kurrizin kukullës por Klara e pëlqen shumë. Fritz me qëllim e përplas dhe e thyen. Klara trishtohet.</p>
                          <p>Gjatë natës, kur të gjithë janë duke fjetur, Klara kthehet në sallon për të parë arrëthyesin e saj të dashur. Ajo i afrohet shtratit të vogël, kur ora tingëllon mesnatë dhe shikon aty Drosselmeyer. Papritur dhoma fillon të mbushet me minj dhe pema e krishtlindjeve fillon të zmadhohet. Edhe arrëthyesi merr përmasa njërëzore dhe Klara e gjen veten në mes të luftës mes një ushtrie biskotash dhe minjsh të udhëhequra nga komandanti i tyre. Ata fillojnë të hanë ushtarët prej biskote.</p>
                          <p>Arrëthyesi është ai që udhëheq ushtarët prej biskote të cilëve i bashkohen edhe kukullat e tjera të cilët shërbejnë si infermierë dhe doktorë që marrin të plagosurit. Ndërkohë që mbreti i minjëve i afrohet arrëthyesit të plagosur, Klara e gjuan me këpucën e saj duke i tërhequr vëmendjen. Kaq mjafton që arrëthyesi ta godasë me thikë.</p>
                          `,
                          audioFiles: [
                            {
                              src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/audio/AKT I-01.mp4",
                              description: "Akti 1, Skena 1 - Përmbledhja e skenave në Shtëpinë e Z. Stahlbaum",
                              alt: "Audio për Aktin I, Skena 1"
                            }
                          ]
              },
              {
                title: "Skena 2: Një pyll me pisha",
                content: `<p>Minjtë tërhiqen dhe arrëthyesi transformohet në një princ të bukur. Princi e merr Klarën me vete në natën e ndricuar nga hëna, në një pyll me pisha ndërkohë që flokët e borës bien rreth tyre në një vallëzim që i shtyn ata drejt mbretërisë së tij.</p>`,
                audioFiles: [
                  {
                    src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/audio/AKT I-02.mp4",
                    description: "Akti 1, Skena 2 - Lufta mes lodrave dhe minjve",
                    alt: "Audio për Aktin I, Skena 2"
                  }
                ]
              }
            ]
          },
          {
            title: "Akti 2",
            scenes: [
              {
                title: "Skena 1: Toka e ëmbëlsirave",
                content: `<p>Klara dhe Princi udhëtojnë në tokën e bukur të ëmbëlsirave, në të cilën Zana e sheqerit ka mbretëruar deri sa vetë princi të kthehej. Ai i tregon asaj per betejën me mbretin eminjve dhe se si Klara i shpëtoi jetën dhe për transformimin e tij përsëri në një princ.</p>
                          <p>Për nder të heroinës së re, nisin festimet me ëmbëlsira nga e gjithë bota, çokollatë nga Spanja, kafe nga Arabia, çaj nga Kina dhe shkopa sheqeri nga Rusia. Të gjithë vallëzojnë e gëzojnë; bareshat Daneze performojnë në flaut, biskotat e vogla prej xhinxheri vallëzojnë rreth nënës së tyre, një varg lulesh të bukura vallëzojnë një vals dhe për ta mbyllur në bukuri vetë Zana e sheqerit dhe Kavalieri i saj bashkohen në vallëzim.</p>
                          <p>Pasi një vals final vallëzohet nga gjithë të pranishmit, zana e sheqerit merr Klarën dhe Princin përdore dhe pasi i jep një puthje Klarës i shtyn ata të ngjiten në slitën e tërhequr nga drerët. Ata largohen në mes përshëndetjesh nga të gjithë të pranishmit.</p>
                        `,
                        audioFiles: [
                          {
                            src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/audio/AKT_II.mp4",
                            description: "Akti 2 - Udhëtimi në Tokën e Ëmbëlsirave",
                            alt: "Audio për Aktin II"
                          }
                        ]
              }
            ]
          }
        ]
      },
      creators: [
        { role: "Kompozitor", name: "Pyotr Ilyich Tchaikovsky" },
        { role: "Bazuar në librin", name: "E.T.A. Hoffmann" },
        { role: "Libreti", name: "Marius Petipa" },
        { role: "Koreografia", name: "Marius Petipa dhe Lev Ivanov" },
        { role: "Dirigjent", name: "Jacopo Sipari di Pescasseroli" },
        { role: "Skenograf", name: "Platon Bardhi" },
        { role: "Kostumograf", name: "Edlira Qyshka" },
        { role: "Mjeshter grimi", name: "Bebeka Alla" },
        { role: "Baletmaester", name: "Alisa Gjoni" },
        { role: "As. Baletmaester", name: "Marco Fagioli" },
        { role: "Dirigjent kori", name: "Dritan Lumshi" }
      ],
      cast: [
        { character: "Klara", performers: ["Sabina Maklekaj, Eles Resuli"] },
        { character: "Arrëthyesi dhe Princi", performers: ["Anxhelo Mucollari, Ervis Koceku"] },
        { character: "Princesha e Embëlsirave", performers: ["Adela Mucollari, Odeta Dishnica"] },
        { character: "Droselmajer", performers: ["Gert Vaso, Dion Gjinika"] },
        { character: "Fritz", performers: ["Armando Meci"] },
        { character: "Mbreti i Minjve", performers: ["Kevin Lila"] },
        { character: "Kukulla Arlekin", performers: ["Enea Qirici"] },
        { character: "Kukulla Kolumbin", performers: ["Isida Mollaymeri"] },
        { character: "Kukulla Ushtar", performers: ["Andi Vrapi"] },
        { character: "Vallja Spanjolle", performers: ["Elda Logo dhe Besi Skura"] },
        { character: "Vallja Arabe", performers: ["Isida Mollymeri dhe Kelvin Lila/ Erisa Gina dhe Erald Zela"] },
        { character: "Vallja Kineze", performers: ["Loreta Bala dhe Renato Lleshi/Andi Vrapi"] },
        { character: "Vallja Ruse", performers: ["Jonida Qafmolla dhe Kristi Dushmani/Livia Lara dhe Enred Miolli"] },
        { character: "Pas de Trois", performers: ["Elona Beqiraj dhe Armando Meci/ Elesa Resuli dhe Sabina Maklekaj"] },
        { character: "Solist Valsi i Luleve", performers: ["Erisa Gina, Jonida Qafmolla, Isida Mollaymeri, Elda Logo, Fatjon Lito, Kevin Lila, Lurdi Dodgjini, Erald Zela"] },
      ],
      audioFiles: [
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/audio/AKT I-01.mp4",
          description: "Akti 1, Pjesa 1 - Përmbledhja e skenave në Shtëpinë e Z. Stahlbaum",
          alt: "Audio për Aktin I, pjesa 1"
        },
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/audio/AKT I-02.mp4",
          description: "Akti 1, Pjesa 2 - Lufta mes lodrave dhe minjve",
          alt: "Audio për Aktin I, pjesa 2"
        },
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/audio/AKT_II.mp4",
          description: "Akti 2 - Udhëtimi në Tokën e Ëmbëlsirave",
          alt: "Audio për Aktin II"
        },
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/audio/ftesa zanore.mp4",
          description: "Ftesë zanore për spektaklin Arrëthyesi",
          alt: "Ftesë zanore për pjesëmarrësit e shikimit të kufizuar"
        }
      ],
      gallery: [
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/gallery/giulia dajci photo2.jpg",
          description: "Foto by Giulia Dajci",
          alt: "Fotografi me ngjyra e skenës me balerinë duke vallëzuar pranë pemës së Krishtlindjeve.",
        },
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/gallery/giulia dajci photo12.jpg",
          description: "Moment i valleve në skenë.",
          alt: "Balet në skenë ku shfaqen figura në kostume historike.",
        },
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/gallery/giulia dajci photo17.jpg",
          description: "Foto by Giulia Dajci",
          alt: "Skenë ku balerinë të veshur si miu mbret përpiqen të sulmojnë Klarën në skenë.",
        },
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/gallery/giulia dajci photo20.jpg",
          description: "Foto by Giulia Dajci",
          alt: "Burrë i verbër në teatër duke rregulluar kufjet për të dëgjuar përshkrimin zanor.",
        },
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/gallery/giulia dajci photo28.jpg",
          description: "Foto by Giulia Dajci",
          alt: "Fotografi me ngjyra që tregon publikun duke përdorur kufje për të dëgjuar përshkrimin.",
        },
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/gallery/giulia dajci photo34.jpg",
          description: "Foto by Giulia Dajci",
          alt: "Foto e një teknik të zërit duke testuar kufjet për audiencën e verbër.",
        },
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/gallery/giulia dajci photo35.jpg",
          description: "Foto by Giulia Dajci",
          alt: "Foto që tregon përshkruesin zanor në kabinën e tij.",
        },
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/gallery/giulia dajci photo41.jpg",
          description: "Foto by Giulia Dajci",
          alt: "Foto e publikut duke duartrokitur dhe duke ndjekur shfaqjen me kufje.",
        },
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/gallery/giulia dajci photo78.jpg",
          description: "Foto by Giulia Dajci",
          alt: "Foto e publikut që ndjek shfaqjen në një ambient të errët dhe të ngrohtë.",
        },
        {
          src: "/programs/artisticPrograms/audioDescriptions/arrethyesi_theNutCracker/gallery/giulia dajci photo83.jpg",
          description: "Foto by Giulia Dajci",
          alt: "Foto e sallës së teatrit me dritat e fikura, ku publiku ndjek shfaqjen.",
        },
      ],
      accessibility: {
        description: "Foto by Giulia Dajci",
        ariaLabel: "Mësoni më shumë për punëtorinë e përshkrimit zanor të avancuar."
      }
    },
    
  ],
  exhibitions: [
    // {
    //   title: "Contemporary Art Exhibition",
    //   subtitle: "Contemporary Art Exhibition",
    //   description: "Explore the latest in contemporary art with this immersive exhibition.",
    //   imgSrc: "/images/artisticProgram/giuliadajciphoto5.jpg",
    //   imgAlt: "Visitors viewing modern art pieces in an exhibition hall",
    //   linkText: "View Exhibition",
    //   category: "exhibition",
    //   addedDate: new Date(),
    //   gallery: [
    //     {
    //       src: "/images/artisticProgram/Arrethyesi.jpg",
    //       description: "First image description",
    //       alt: "This is the image alt 1",
    //     },
    //     {
    //       src: "/images/artisticProgram/Arrethyesi2.jpg",
    //       description: "Second image description",
    //       alt: "This is the image alt 2",
    //     },
    //     {
    //       src: "/images/artisticProgram/Arrethyesi3.jpg",
    //       description: "Third image description",
    //       alt: "This is the image alt 3",
    //     }
    //   ],
    //   accessibility: {
    //     altText: "Visitors looking at contemporary art in an exhibition hall.",
    //     ariaLabel: "View the Contemporary Art Exhibition"
    //   }
    // },
  ]
};

const updatedArtisticProgram = Object.keys(artisticProgram).reduce((acc, category) => {
  acc[category] = artisticProgram[category]
    .map(program => ({
      ...program,
      id: slugify(program.title), // Use slugified title as the ID
      linkPath: `/program/${slugify(program.title)}`, // Create a slugified linkPath
      accessibility: program.accessibility || {}, // Ensure accessibility information is carried over
    }))
    .sort((a, b) => new Date(b.addedDate) - new Date(a.addedDate)); // Sort by addedDate in descending order
  return acc;
}, {});

export default updatedArtisticProgram;